import React from "react";
import { Card, Grid, LinearProgress, Typography } from "@mui/joy";

const METRICS = [
  { title: "Total seva hours", value: "184", helper: "+12% vs last month" },
  { title: "Donations this month", value: "₹75,400", helper: "Goal: ₹1,00,000", progress: 75 },
  { title: "Families supported", value: "28", helper: "You lit 28 homes with bhakti" },
];

export function MetricsSection() {
  return (
    <Grid container spacing={2.5}>
      {METRICS.map((metric) => (
        <Grid key={metric.title} xs={12} md={4}>
          <Card variant="outlined" sx={{ borderRadius: "xl", p: 2.5, gap: 1.2 }}>
            <Typography level="title-sm" sx={{ textTransform: "uppercase", letterSpacing: 0.8, color: "text.tertiary" }}>
              {metric.title}
            </Typography>
            <Typography level="h2" sx={{ fontWeight: 700 }}>
              {metric.value}
            </Typography>
            <Typography level="body-sm" sx={{ color: "text.secondary" }}>
              {metric.helper}
            </Typography>
            {typeof metric.progress === "number" && (
              <LinearProgress determinate value={metric.progress} sx={{ mt: 1 }} />
            )}
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
